import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo.svg",
  alt: "logo",
  class: "logo"
}, null, -1)
const _hoisted_3 = { class: "navbar__list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/icon-close.svg",
  alt: "close"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/icon-menu.svg",
  alt: "menu"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  emits: ["active-changed"],
  setup(__props, { emit }) {



const tabsValues: string[] = [
  "home",
  "about",
  // "skills",
  // "portfolio",
  // "contact",
];

const activeTab = ref("home");
const changeActiveTab = (item: string) => {
  activeTab.value = item;
  emit("active-changed", activeTab.value);
};

const isNavbar = ref(window.innerWidth > 770 ? true : false);
const openNav = () => {
  isNavbar.value = true;
};

const closeNav = () => {
  if (window.innerWidth <= 770) isNavbar.value = false;
};

window.addEventListener("resize", () => {
  if (window.innerWidth > 770 && !isNavbar.value) {
    isNavbar.value = true;
  } else if (window.innerWidth <= 770 && isNavbar.value) {
    isNavbar.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createVNode(_Transition, {
      name: "slideFromLeft",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabsValues, (item) => {
            return _createElementVNode("li", {
              class: _normalizeClass(["navbar__item navbar__link", { active: item == activeTab.value }]),
              key: item,
              onClick: ($event: any) => {
            changeActiveTab(item);
            closeNav();
          }
            }, _toDisplayString(item), 11, _hoisted_4)
          }), 64)),
          _createVNode(_Transition, {
            name: "slideFromTop",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (isNavbar.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "navbar__menu--close",
                    onClick: closeNav
                  }, _hoisted_6))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 512), [
          [_vShow, isNavbar.value]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slideFromTop",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "navbar__menu--btn",
          onClick: openNav
        }, _hoisted_8)
      ]),
      _: 1
    })
  ]))
}
}

})